<template>
  <div class="container-fluid  ">
    <div class="row">
      <div class="col-12">
        <h2 class="mb ">Create New Company</h2>
      </div>

      <!--      FORM-->
      <div class="col-4">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="form-group col-12">
              <label>Company Name</label>
              <input v-model="form.companyName" type="text" class="form-control" required/>
            </div>

            <div class="form-group col-12">
              <label>Departments</label>
              <div v-for="(department, index) in form.departments" :key="index" class="input-group mb-2">
                <input v-model="form.departments[index]" class="form-control" placeholder="Department.."/>
                <div class="input-group-append">
                  <button class="btn btn-outline-danger" type="button" @click="removeItem(form.departments, index)">🗑
                  </button>
                </div>
              </div>

              <Button :color="getColors.defaultColorSolidButton"
                      :outline="false"
                      :disabled="false"
                      :display="'inline'"
                      type="button"
                      class="w-100 h-2 mb"
                      :width="'calc(100% - 5px)'"
                      :padding="'2px 0'"
                      @frameworkButtonClicked="form.departments.push('')"
                      :backgroundColor="getColors.defaultBackgroundColorButton"
                      :size="'small'">
                <template #button-content><span>Add Department</span></template>
              </Button>

            </div>

            <div class="form-group col-6">
              <label>Activities</label>
              <div v-for="(activity, index) in form.activities" :key="index" class="input-group mb-2">
                <input v-model="form.activities[index]" class="form-control" placeholder="Activity.."/>
                <div class="input-group-append">
                  <button class="btn btn-outline-danger" type="button" @click="removeItem(form.activities, index)">🗑
                  </button>
                </div>
              </div>

              <Button :color="getColors.defaultColorSolidButton"
                      :outline="false"
                      :disabled="false"
                      :display="'inline'"
                      type="button"
                      class="w-100 h-2 mb"
                      :width="'calc(100% - 5px)'"
                      :padding="'2px 0'"
                      @frameworkButtonClicked="form.activities.push('')"
                      :backgroundColor="getColors.defaultBackgroundColorButton"
                      :size="'small'">
                <template #button-content><span>Add Activity</span></template>
              </Button>
            </div>

            <div class="form-group col-6">
              <label>Workflows</label>
              <div v-for="(workflow, index) in form.workflows" :key="index" class="input-group mb-2">
                <input v-model="form.workflows[index]" class="form-control" placeholder="Lijn 1.."/>
                <div class="input-group-append">
                  <button class="btn btn-outline-danger" type="button" @click="removeItem(form.workflows, index)">🗑
                  </button>
                </div>
              </div>

              <Button :color="getColors.defaultColorSolidButton"
                      :outline="false"
                      :disabled="false"
                      :display="'inline'"
                      type="button"
                      class="w-100 h-2 mb"
                      :width="'calc(100% - 5px)'"
                      :padding="'2px 0'"
                      @frameworkButtonClicked="form.workflows.push('')"
                      :backgroundColor="getColors.defaultBackgroundColorButton"
                      :size="'small'">
                <template #button-content><span>Add Workflow</span></template>
              </Button>

            </div>
            <div class="form-group col-12">
              <label>  Logo for kiosk (Image)</label>
              <input type="file" class="form-control" @change="handleImageUpload" accept="image/*"/>
              <small v-if="form.imageBase64" class="form-text text-muted">
                Image encoded as base64 and ready to send.
              </small>
            </div>
            <div class="form-group col-12">
              <label>Email Prefix for admin account</label>
              <input v-model="form.emailPrefix" class="form-control" required/>
              <small class="form-text text-muted">Full login for admin will be: <strong>{{
                  form.emailPrefix
                }}@motivate.nl</strong></small>
            </div>

            <div class="form-group col-6">
              <label>Password</label>
              <input v-model="form.password" type="password" class="form-control" required/>
            </div>
            <div class="form-group col-6">
              <label>Confirm Password</label>
              <input v-model="form.confirmPassword" type="password" class="form-control" required/>
              <small v-if="form.confirmPassword && form.confirmPassword !== form.password" class="text-danger">
                Passwords do not match.
              </small>
            </div>
          </div>
          <hr>
          <Button :color="getColors.defaultColorSolidButton"
                  :outline="false"
                  :disabled="false"
                  :display="'inline'"
                  type="submit"
                  class="w-100 h-2 mb"
                  :width="'calc(100% - 5px)'"
                  :padding="'2px 0'"
                  @frameworkButtonClicked="form.workflows.push('')"
                  :backgroundColor="getColors.defaultBackgroundColorButton"
                  :size="'small'">
            <template #button-content><span>Create the company 🚀 </span></template>
          </Button>
          <div v-if="message" class="alert mt-4" :class="messageClass" role="alert">
            {{ message }}
          </div>
        </form>
      </div>


      <div class="col-8">
      <pre v-if="!apiResponseSuccess">
        {{ form }}
      </pre>

        <div v-if="apiResponseSuccess">

          <!--          <h3 class="alert alert-info">{{-->
          <!--              apiResponseSuccess.message-->
          <!--            }}</h3>-->
          <!--          {{apiResponseSuccess}}-->

          <div>
            <!-- Main Data Table -->
            <h4 class="text-primary">Main Data</h4>
            <table border="1" class="table table-bordered">
              <thead>
              <tr style="font-weight: 700">
                <th>Key</th>
                <th>Value</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(value, key) in flatMainData" :key="key">
                <td style="font-weight: 700">{{ key }}</td>
                <td v-html="key === 'genericKioskUrl' ? `<a href='${value}' target='_blank'>${value}</a>` : value"></td>
              </tr>
              </tbody>
            </table>

            <!-- Hardware Counters Table -->
            <!--            {{getWorkflowData}}-->

            <!-- Loop through each workflow -->
            <div v-for="(workflow, index) in getWorkflowData()" :key="index" class="mt-4">
              <h4 class="text-primary">Workflow: {{ workflow.name }}</h4>
              <table border="1" class="table table-bordered">
                <thead>
                <tr style="font-weight: 700">
                  <th>Key</th>
                  <th>Value</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(val, key) in workflow" :key="key">
                  <td style="font-weight: 700">{{ key }}</td>
                  <td v-html="key === 'kioskUrl' ? `<a href='${val}' target='_blank'>${val}</a>` : val"></td>

                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Button from "@/components/ui/Button.vue";
import colors from '@/assets/scss/MotivateColors.scss'

export default {
  components: {Button},
  data() {
    return {
      form: {
        companyName: '',
        activities: [''],
        departments: [''],
        workflows: [''],
        emailPrefix: '',
        password: '',
        confirmPassword: '',
        imageBase64:''
      },
      message: '',
      apiResponseSuccess: null,
      isError: false
    };
  },
  computed: {
    messageClass() {
      return this.isError ? 'alert-danger' : 'alert-success';
    },
    getColors() {
      return colors
    },
    flatMainData() {
      const result = {};
      const flatten = (obj, prefix = "") => {
        for (const key in obj) {
          if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
          if (key === "hardwareCounters") continue; // Skip hardwareCounters
          const val = obj[key];
          const newKey = prefix ? `${prefix}.${key}` : key;
          if (typeof val === "object" && val !== null && !Array.isArray(val)) {
            flatten(val, newKey);
          } else {
            result[newKey] = val;
          }
        }
      };
      flatten(_.pick(this.apiResponseSuccess.data, ["companyId", "genericKioskUrl",'genericOverviewDashboard']));
      return result;
    },


  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        this.form.imageBase64 = reader.result;
      };
      reader.readAsDataURL(file);
    },
    getWorkflowData() {
      const data = this.apiResponseSuccess && this.apiResponseSuccess.data;
      if (
          data &&
          data.hardwareCounters &&
          data.hardwareCounters.counters &&
          data.workflows
      ) {
        return Object.keys(data.workflows).map((key) => {
          const workflow = data.workflows[key];
          const counter = data.hardwareCounters.counters[workflow.id];
          return {
            name: key,
            ...workflow,
            advantechCloudBaseUrl: data.hardwareCounters.baseUrl,
            advantechCloudEnpoint: data.hardwareCounters.endpoint,
            advantechUID: counter ? counter.id : 'N/A'
          };
        });
      }
      return [];
    },

    removeItem(array, index) {
      array.splice(index, 1);
    },
    async handleSubmit() {
      if (this.form.password !== this.form.confirmPassword) {
        this.message = "Passwords do not match.";
        this.isError = true;
        return;
      }
      try {
        const payload = {
          companyName: this.form.companyName,
          activities: this.form.activities.filter(Boolean),
          departments: this.form.departments.filter(Boolean),
          workflows: this.form.workflows.filter(Boolean),
          email: `${this.form.emailPrefix}@motivate.nl`,
          password: this.form.password,
          kioskImage:this.form.imageBase64
        };
        console.log(payload)
        const user = this.$FirebaseAuth.getUser();

        const idToken = await user.getIdToken();

        // Make the API call using axios
        try {
          const response = await axios.post(
              // 'http://127.0.0.1:5098/performance-management-tool/europe-west1/http_api/create-company',
              'https://europe-west1-performance-management-tool.cloudfunctions.net/http_api/create-company',

              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  // The token is added to the header here
                  'motivate-auth': idToken
                }
              }
          );
          console.log('Company created successfully:', response.data);
          this.apiResponseSuccess = response.data;

        } catch (error) {
          console.error('Error creating company:', error.response ? error.response.data : error.message);
          throw error;
        }


        // this.message = result.message || 'Company created successfully!';
        // this.isError = false;
      } catch (err) {
        console.error(err);
        this.message = 'Error occurred during company creation.';
        this.isError = true;
      }
    }
  },
  created() {
    // this.apiResponseSuccess = {
    //   "message": "Company and related data created successfully.",
    //   "data": {
    //     "companyId": "QiEN5tRAVThRcrYShtFg",
    //     "userId": "I79Vij2wvFUq5ibyJRr2jGW7BX03",
    //     "workflows": {
    //       "test": {
    //         "id": "YNqK9gVwHd8UlHsPIMQG",
    //         "kioskUrl": "https://performance.motivate.nl/kiosk/PZX2gzMTvLSo5JQs9Poa/EvGNGFkg7aW2pTdRvDWd8odnB5p0k9ON"
    //       }
    //     },
    //     "genericKioskUrl": "https://performance.motivate.nl/kiosk/pzVSuwbbWOtsaJrIptd7/pNQZskbvMG1uqRxkmwfXpMnvJ3JjTTjW",
    //     "hardwareCounters": {
    //       "baseUrl": "europe-west1-performance-management-tool.cloudfunctions.net",
    //       "endpoint": "/http_http/motivateCounter/advantechwise/QiEN5tRAVThRcrYShtFg",
    //       "counters": {
    //         "YNqK9gVwHd8UlHsPIMQG": {
    //           "id": "Y1wFv5tZQplJM3BbWUWz",
    //           "companyId": "QiEN5tRAVThRcrYShtFg",
    //           "hardwareLatestTimestamp": {
    //             "_seconds": 1754638637,
    //             "_nanoseconds": 719000000
    //           },
    //           "inputs": {
    //             "0": {
    //               "PE": "128",
    //               "counter": 0,
    //               "workflowId": "YNqK9gVwHd8UlHsPIMQG"
    //             },
    //             "1": null,
    //             "2": null,
    //             "3": null
    //           },
    //           "name": "test",
    //           "timestamp": {
    //             "_seconds": 1754638637,
    //             "_nanoseconds": 719000000
    //           },
    //           "type": ""
    //         }
    //       }
    //     }
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_overwritesNewUi.scss";
@import "@/assets/scss/workflowInterface/form.scss";
@import "@/assets/scss/MotivateColors.scss";

.text-primary, a {
  color: $ceruleanBlue !important;
}

td, tr, thead, th {
  border-color: $besWelBlack !important;
  color: $besWelBlack;
}

th {
  background: $ceruleanBlue;
  color: white;
}
</style>